import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Language } from '../../interfaces/language.model';
import { Storage } from '@ionic/storage';

@Injectable()
export class LanguageProvider {

  languages: Language[];
  selectedLang: string;

  constructor(public http: HttpClient, public storage: Storage) {}

  getLanguages() {
    return this.storage.get("languages").then((data:Language[]) => {
      this.languages = data;
    });
  }

  getAllLanguages(){
    return this.languages;
  }

  setSelectedLang(language: string): Promise<any> {
    console.log("LanguageProvider::setSelectedLang: ",language);
    this.selectedLang = language;
    return this.storage.set("selectedLanguage", this.selectedLang);
  }

  getSelectedLang(){
    return this.storage.get("selectedLanguage");
  }
}



// WEBPACK FOOTER //
// ./src/providers/language/language.ts